import Vue from 'vue';
import {DateTime} from 'luxon';

export function installFilters() {
    Vue.filter('shortDate', (value: string) => {
        return DateTime.fromISO(value, { zone: 'America/Chicago'}).toLocaleString(DateTime.DATE_SHORT);
    });
    Vue.filter('dotFormattedDate', (value: string) => {
        return DateTime.fromISO(value, { zone: 'America/Chicago'}).toFormat('MM.dd.yyyy');
    });
    Vue.filter('simpleTime', (value: string) => {
        return DateTime.fromISO(value, {zone: 'America/Chicago'}).toLocaleString(DateTime.TIME_SIMPLE);
    });
}